import { AnswerInfo } from "./answer-info";

export class MultipleChoiceQuestion {
    public QuestionId: string;
    public QuestionKey: string;
    public QuestionText: string;
    public ChoicesResourceKey: string;
    public Choices: AnswerInfo[];
    public Section: string;
    public Sequence: string;
    public Hidden: boolean;
  }